export const calculateTotalPrice = (orderItems) =>
	orderItems.reduce((acc, orderItem) => acc + orderItem.price, 0);
